import { render, staticRenderFns } from "./frameShow.vue?vue&type=template&id=85b0bd98&scoped=true"
import script from "./frameShow.vue?vue&type=script&lang=js"
export * from "./frameShow.vue?vue&type=script&lang=js"
import style0 from "./frameShow.vue?vue&type=style&index=0&id=85b0bd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b0bd98",
  null
  
)

export default component.exports